export enum InstitutionContactChannel {
  CREATE = 'institutionContact::create',
  EDIT = 'institutionContact::patch',
  DELETE = 'institutionContact::delete',
}
